export const TEST_MS = 10;
export const TYPING_MS = 150;
export default {
  TEST_MS,
  TYPING_MS
};